module.exports = __webpack_public_path__ + "static/years_bubble-edab1d45b8699347eaf6fd64b962144a.png";